import MuiListItemText from '@material-ui/core/ListItemText';

export default MuiListItemText;
